import React from 'react';

export default ({ data }) => (
  <div className="social-wrapper">
    <a href="https://soundcloud.com/ravereviewz" target="_blank">
      <img src="/img/rave-reviewz-show.jpg" />
    </a>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/RadioShow.js